module.exports = __webpack_public_path__ + "img/monster-4.7845138e.png";